<template>
  <div>
    <v-container fluid>
      <v-skeleton-loader
        :loading="!flagNav"
        transition="scale-transition"
        max-height="64"
        type="table-heading"
      >
        <v-toolbar :image="SubNavbarBackGround" dark class="header-title text-white">
          <v-toolbar-title class="title" :style="'color: #' + FontColorTitle">Intent Group</v-toolbar-title>
          <v-spacer />
          <div class="d-flex pr-4">
            <v-toolbar-title class="title" :style="'color: #' + FontColorTitle">{{ today }}</v-toolbar-title>
          </div>
        </v-toolbar>
      </v-skeleton-loader>
      <v-card class="card2" style="margin-top: 1rem">
        <v-card-text>
          <v-row align="center">
            <v-col cols="12" md="6">
              <v-card variant="outlined" class="pa-2 search-panel">
                <v-row no-gutters>
                  <v-col cols="9" class="pa-2">
                    <!-- <v-text-field id="input-search-groupname-intentgroup" :label="'Intent Group Name'" v-model="searchName" density="comfortable"
                            variant="outlined"></v-text-field> -->
                    <v-text-field
                      id="input-search-groupname-intentgroup"
                      label="Intent Group Name"
                      v-model="searchName"
                      @keydown.enter="Search"
                      density="comfortable"
                      variant="outlined"
                      prepend-inner-icon="mdi-clipboard-text-search-outline"
                      hide-details
                      clearable
                      color="primary"
                    ></v-text-field>
                  </v-col>
                  <v-col cols="3" class="pa-2 d-flex align-center justify-end">
                    <v-btn
                      id="button-search-gptmodelmanagement"
                      color="primary"
                      class="ml-2"
                      variant="elevated"
                      @click="Search"
                    >
                      <v-icon start>mdi-magnify</v-icon>
                      {{ $t("search") }}
                    </v-btn>
                  </v-col>
                </v-row>
              </v-card>
            </v-col>
            <v-col cols="12" sm="6" class="d-flex flex-wrap justify-end gap-2">
              <v-btn
                v-if="canAdd"
                id="button-add-intentgroup"
                color="primary"
                class="control-btn create-btn"
                variant="elevated"
                size="large"
                prepend-icon="mdi-plus-circle"
                rounded="xl"
                @click="Add()"
              >
                <span class="btn-text">{{ $t("add") }}</span>
              </v-btn>
            </v-col>
          </v-row>
        </v-card-text>
        <v-data-table-server
          class="modern-table"
          v-model:options="options"
          :items-per-page="itemsPerPage"
          :items-length="searchTotalTable"
          :items="dataTable"
          :headers="headers"
          :loading="loadingTable"
        >
          <template v-slot:item="{ item }">
            <tr>
              <td style="text-align: center">{{ item.number }}</td>
              <td>{{ item.name }}</td>
              <td>{{ substring(item.intentSessionName) }}</td>
              <td style="text-align: center">{{ item.createBy }}</td>
              <td style="text-align: center">
                <div class="action-group" style="justify-content: center;">
                  <!-- Edit -->
                  <v-btn
                    id="button-edit-intentgroup"
                    variant="text"
                    density="comfortable"
                    @click="Edit(item)"
                    class="action-btn edit-btn"
                    icon
                  >
                    <v-icon size="18">{{ canEdit ? 'mdi-pencil-outline' : 'mdi-eye-outline' }}</v-icon>
                  </v-btn>
                  <!-- Custom Divider -->
                  <div v-if="canDelete" class="action-divider"></div>

                  <!-- Delete -->
                  <v-btn
                    v-if="canDelete"
                    id="button-delete-intentgroup"
                    variant="text"
                    density="comfortable"
                    @click="Delete(item.intentGroupID)"
                    class="action-btn delete-btn"
                    icon
                    :disabled="btnDisableDelete(item)"
                  >
                    <v-icon size="18">mdi-delete-outline</v-icon>
                  </v-btn>
                </div>
              </td>
            </tr>
          </template>
        </v-data-table-server>
      </v-card>
    </v-container>
    <v-overlay :model-value="dialog" class="align-center justify-center" persistent>
      <v-card class="loading-card" elevation="8">
        <v-card-text class="text-center">
          <v-progress-circular
            indeterminate
            size="64"
            color="primary"
            class="mb-4"
          ></v-progress-circular>
          <h3 class="loading-title">Loading...</h3>
          <p class="loading-subtitle">Please wait</p>
        </v-card-text>
      </v-card>
    </v-overlay>
    <!-- Edit -->
    <v-dialog v-model="EditIntentGroup" max-width="1000">
      <v-card>
        <v-card-title class="text-h5 grey lighten-2">
          {{ canEdit ? $t("edit") : $t("view") }}
        </v-card-title>
        <v-card-text style="margin-top: 1rem">
          <v-row>
            <v-col cols="12" sm="12" md="4">
              <v-text-field
                id="groupintentname-edit-intentgroup"
                :label="$t('groupIntentName')"
                v-model="GroupIntent.Name"
                :rules="[rules.required]"
                required
                outlined
                dense
              >
                <template v-slot:append-outer>
                  <v-tooltip location="top" max-width="300">
                    <template v-slot:activator="{ props }">
                      <v-icon
                        text
                        x-small
                        style="position: absolute; top: 0px; right: -6px"
                        v-bind="props"
                        >mdi-information-outline</v-icon
                      >
                    </template>
                    <span>{{ $t("_InfoGroupModelName") }}</span>
                  </v-tooltip>
                </template>
              </v-text-field>
            </v-col>
          </v-row>
          <v-row style="margin-top: 0">
            <v-col cols="12" sm="12" md="12">
              <v-autocomplete
                id="edit-model-intentgroup"
                :label="$t('model')"
                v-model="GroupIntent.IntentSession"
                :items="DDIntentSession"
                item-title="name"
                item-value="id"
                chips
                clearable
                deletable-chips
                multiple
                outlined
              >
                <template v-slot:append-outer>
                  <v-tooltip location="top" max-width="300">
                    <template v-slot:activator="{ props }">
                      <v-icon
                        text
                        x-small
                        style="position: absolute; top: 0px; right: -6px"
                        v-bind="props"
                        >mdi-information-outline</v-icon
                      >
                    </template>
                    <span>{{ $t("_InfoModelinGroup") }}</span>
                  </v-tooltip>
                </template>
              </v-autocomplete>
            </v-col>
          </v-row>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            id="button-close-edit-intentgroup"
            color="blue darken-1"
            variant="text"
            @click="EditIntentGroup = false"
            >{{ $t("close") }}</v-btn
          >
          <v-btn
            v-if="canEdit"
            id="button-save-edit-intentgroup"
            color="blue darken-1"
            variant="text"
            @click="Save()"
            >{{ $t("save") }}</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>
    <!-- Add -->
    <v-dialog v-model="AddIntentGroup" max-width="1000">
      <v-card>
        <v-card-title
          class="text-h5 grey lighten-2"
          style="position: sticky; top: 0px"
        >
          {{ $t("add") }}
        </v-card-title>
        <v-card-text style="margin-top: 1rem">
          <v-row>
            <v-col cols="12" sm="12" md="4">
              <v-text-field
                id="groupintentname-add-intentgroup"
                :label="$t('groupIntentName')"
                v-model="GroupIntent.Name"
                :rules="[rules.required]"
                required
                outlined
                dense
              >
                <template v-slot:append-outer>
                  <v-tooltip location="top" max-width="300">
                    <template v-slot:activator="{ props }">
                      <v-icon
                        text
                        x-small
                        style="position: absolute; top: 0px; right: -6px"
                        v-bind="props"
                        >mdi-information-outline</v-icon
                      >
                    </template>
                    <span>{{ $t("_InfoGroupModelName") }}</span>
                  </v-tooltip>
                </template>
              </v-text-field>
            </v-col>
          </v-row>
          <v-row style="margin-top: 0">
            <v-col cols="12" sm="12" md="12">
              <v-autocomplete
                id="add-model-intentgroup"
                :label="$t('model')"
                v-model="GroupIntent.IntentSession"
                :items="DDIntentSession"
                item-text="name"
                item-value="id"
                chips
                clearable
                deletable-chips
                multiple
                outlined
                :rules="[rules.required]"
                required
                dense
              >
                <template v-slot:append-outer>
                  <v-tooltip location="top" max-width="300">
                    <template v-slot:activator="{ props }">
                      <v-icon
                        text
                        x-small
                        style="position: absolute; top: 0px; right: -6px"
                        v-bind="props"
                        >mdi-information-outline</v-icon
                      >
                    </template>
                    <span>{{ $t("_InfoModelinGroup") }}</span>
                  </v-tooltip>
                </template>
              </v-autocomplete>
            </v-col>
          </v-row>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            id="button-close-add-intentgroup"
            color="blue darken-1"
            variant="text"
            @click="AddIntentGroup = false"
            >{{ $t("close") }}</v-btn
          >
          <v-btn
            v-if="canAdd"
            id="button-save-add-intentgroup"
            color="blue darken-1"
            variant="text"
            @click="Save()"
            >{{ $t("save") }}</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>
<script>
import checkPermissionTwo from "@/api/function.js";
import dateUtils from "../plugins/date-utils";
import moment from "moment";
import editImg from "@/assets/edit1.png";
import deleteImg from "@/assets/delete1.png";
export default {
  name: "IntentGroup",
  inject: [
    "flagNav",
    "FontColorTitle",
    "SubNavbarBackGround",
    "Username",
    "RoleId"
  ],
  components: {},
  mixins: [checkPermissionTwo],
  data: () => ({
    loadingTable: false,
    today: null,
    searchName: null,
    AddIntentGroup: false,
    EditIntentGroup: false,
    options: {
      page: 1,
      itemsPerPage: 10,
      sortBy: [],
      sortDesc: [],
    },
    dataTable: [],
    itemsPerPage: 10,
    searchTotalTable: 0,
    totalTable: 0,
    dialog: false,
    DDIntentSession: [],
    images: {
      edit: editImg,
      delete: deleteImg,
    },
    rules: {
      required: (value) => !!value || "Required.",
    },
    GroupIntent: {
      IntentGroupID: null,
      Name: null,
      IntentSession: null,
    },
    sortBy: [],
    sortDesc: [],
    isFirst: true,
    isSearch: false,
  }),
  computed: {
    isViewOnly() {
      return this.$pagePermission && this.$pagePermission.isViewOnly('IntentGroup');
    },
    canAdd() {
      return !!(this.$pagePermission && this.$pagePermission.canAdd('IntentGroup'));
    },
    canEdit() {
      return !!(this.$pagePermission && this.$pagePermission.canEdit('IntentGroup'));
    },
    canDelete() {
      return !!(this.$pagePermission && this.$pagePermission.canDelete('IntentGroup'));
    },
    permissions() {
      return {
        add: this.$pagePermission && this.$pagePermission.canAdd('IntentGroup'),
        edit: this.$pagePermission && this.$pagePermission.canEdit('IntentGroup'),
        delete: this.$pagePermission && this.$pagePermission.canDelete('IntentGroup'),
      }
    },
    headers() {
      return [
        { title: this.$t("no"), align: "center", sortable: false, width: "10%" },
        {
          title: "Intent Group Name",
          value: "Name",
          align: "center",
          sortable: true,
          width: "20%",
        },
        {
          title: "Intent Session",
          value: "IntentSessionName",
          align: "center",
          sortable: false,
          width: "45%",
          class: "wrap-text",
        },
        {
          title: "Create By",
          value: "CreateBy",
          align: "center",
          sortable: true,
          width: "15%",
        },
        {
          title: this.$t("action"),
          align: "center",
          sortable: false,
          width: "15%",
        },
      ];
    },
  },
  watch: {
    options: {
    handler() {
      this.Get();
    },
    deep: true,
    immediate: true,
  },
  },
  methods: {
    btnDisableDelete(item) {
      if ((this.RoleId == 2 || this.RoleId == 6) && item.createBy != this.Username) {
        return true;
      }
      return false;
    },
    Get() {
      let self = this;
      // self.dialog = true;
      self.loadingTable = true;
      
      let { page, itemsPerPage, sortBy } = self.options;
      let sortField = null;
      let sortOrder = null;

      if (sortBy && sortBy.length > 0) {
        sortField = sortBy[0].key;
        sortOrder = sortBy[0].order === 'desc';
      }
      let temp = {
        page: self.isSearch ? 1 : page,
        perPage: itemsPerPage != -1 ? itemsPerPage : self.totalTable,
        DataName: self.searchName,
        sortDesc: sortOrder,
        sortBy: sortField,
      };
      self.$call.GetTableIntentGroup(
        temp,
        (dataResponse) => {
          if (dataResponse.status == 0) {
            self.searchTotalTable = dataResponse.data.total;
            self.dataTable = dataResponse.data.data;
            self.totalTable = self.isFirst
              ? dataResponse.data.total
              : self.totalTable;
          } else {
            self.dataTable = [];
            self.searchTotalTable = 0;
            self.totalTable = 0;
          }
          if (self.isFirst) {
            this.GetDDIntentSession();
          }
          // self.dialog = false;
          self.loadingTable = false;
          self.isSearch = false;
          self.isFirst = false;
        },
        (errorResource) => {
          // self.dialog = false;
          self.loadingTable = false;
          self.isSearch = false;
          console.error(errorResource);
        }
      );
    },
    Search() {
      let self = this;
      self.options.page = 1;
      self.Get();
    },
    async Save() {
      let self = this;
      try {
        if (
          self.GroupIntent.Name == "" ||
          self.GroupIntent.Name == null ||
          self.GroupIntent.IntentSession == "" ||
          self.GroupIntent.IntentSession == null
        ) {
          self.$swal.fire({
            icon: "warning",
            title: self.$t("warning"),
            text: self.$t("warningFillAll"),
            showConfirmButton: false,
            timer: 1800,
          });
          return;
        }
        self.dialog = true;
        if (self.AddIntentGroup) {
          await self.$call.CreateIntentGroup(
            self.GroupIntent,
            async (dataResponse) => {
              if (dataResponse.status == 0) {
                self.$swal.fire({
                  icon: "success",
                  title: dataResponse.message,
                  showConfirmButton: false,
                  timer: 1500,
                });
                self.totalTable = self.totalTable + 1;
                self.Get();
                self.AddIntentGroup = false;
              } else if (dataResponse.status == 3) {
                self.$swal.fire({
                  icon: "warning",
                  title: dataResponse.message,
                  showConfirmButton: false,
                  timer: 2000,
                });
              }
              self.dialog = false;
            },
            (errorResource) => {
              self.dialog = false;
              self.AddIntentGroup = false;
              console.error(errorResource);
            }
          );
        } else if (self.EditIntentGroup) {
          await self.$call.UpdateIntentGroup(
            self.GroupIntent,
            async (dataResponse) => {
              if (dataResponse.status == 0) {
                self.$swal.fire({
                  icon: "success",
                  title: dataResponse.message,
                  showConfirmButton: false,
                  timer: 1500,
                });
                self.Get();
                self.EditIntentGroup = false;
              } else if (dataResponse.status == 3) {
                self.$swal.fire({
                  icon: "warning",
                  title: dataResponse.message,
                  showConfirmButton: false,
                  timer: 2000,
                });
              }
              self.dialog = false;
            },
            (errorResource) => {
              self.dialog = false;
              self.Editdialog = false;
              console.error(errorResource);
            }
          );
        }
      } catch (error) {
        this.LogTrace(error, "DeleteGroup");
      }
    },
    Add() {
      let self = this;
      self.GroupIntent.IntentGroupID = null;
      self.GroupIntent.Name = null;
      self.GroupIntent.IntentSession = null;
      // self.AddIntentGroup = true;
      self.$router.push({
        name: "IntentSession",
        query: {
          id: null,
        },
      });
    },
    // Edit(item) {
    //   let self = this;
    //   self.EditIntentGroup = true;
    //   self.GroupIntent.IntentGroupID = item.intentGroupID;
    //   self.GroupIntent.Name = item.name;
    //   self.GroupIntent.IntentSession = item.intentSession;
    // },
    Edit(item) {
      let self = this;
      self.$router.push({
        name: "IntentSession",
        query: {
          id: item.intentGroupID,
        },
      });
    },
    Delete(id) {
      let self = this;
      try {
        self.$swal
          .fire({
            title: this.$t("ConfirmDeletion"),
            text: this.$t("confirmDeletionIntentGroup"),
            icon: "warning",
            showCancelButton: true,
            confirmButtonColor: "#3085d6",
            cancelButtonColor: "#d33",
            confirmButtonText: this.$t("confirm"),
            cancelButtonText: this.$t("cancel"),
            reverseButtons: false,
          })
          .then((result) => {
            if (result.isConfirmed) {
              self.dialog = true;
              self.$call.DeleteIntentGroup(
                { IntentGroupID: id },
                (dataResponse) => {
                  self.dialog = false;
                  if (dataResponse.status == 0) {
                    self.$swal.fire({
                      icon: "success",
                      title: dataResponse.message,
                      showConfirmButton: false,
                      timer: 1500,
                    });
                    self.Get();
                  }else if (dataResponse.status == 1) {
                    self.$swal.fire({
                      icon: "error",
                      title: dataResponse.message,
                      showConfirmButton: true,
                      confirmButtonText: this.$t("gotIt"),
                      confirmButtonColor: "#d33",
                    });
                  }
                },
                (errorResource) => {
                  self.dialog = false;
                  console.error(errorResource);
                }
              );
              self.Get();
            }
          });
      } catch (error) {
        this.LogTrace(error, "DeleteGroup");
      }
    },
    convertDateToString(date, seperator = "/") {
      return dateUtils.getStringWithTimeFromDate(
        moment(date).toDate(),
        seperator
      );
    },
    GetDate() {
      let today1 = new Date();
      let dd = today1.getDate();
      let mm = today1.getMonth() + 1; //January is 0!
      let yyyy = today1.getFullYear();
      if (dd < 10) {
        dd = "0" + dd;
      }
      if (mm < 10) {
        mm = "0" + mm;
      }
      this.today = dd + "/" + mm + "/" + yyyy;
    },
    GetDDIntentSession() {
      let self = this;
      self.loadingTable = true;
      self.$call.DDIntentSession(
        (dataResponse) => {
          if (dataResponse.status == 0) {
            self.DDIntentSession = dataResponse.data;
          } else {
            self.DDIntentSession = [];
          }
          self.loadingTable = false;
        },
        (errorResource) => {
          self.loadingTable = false;
          console.error(errorResource);
        }
      );
    },
    substring(text) {
      if (text != null) {
        if (text.length > 50) {
          return text.substring(0, 50) + "...";
        }
        return text;
      }
      return text;
    },
  },
  mounted() {
    this.GetDate();
    this.Get();
    
  },
};
</script>
<style scoped>
.card2 {
  border-radius: 10px !important;
  margin-bottom: 2rem;
  padding-top: 1rem;
}

.card {
  border-radius: 10px !important;
  margin-bottom: 2rem;
  height: 90vh;
  overflow: auto;
  padding: 0;
}

.flex {
  margin-left: 2rem;
  margin-right: 2rem;
}

.v-tooltip {
  background-color: #333;
  color: #fff;
}
.AddColumn:hover {
  background-color: #1976d2 !important;
  color: white !important;
}
:deep(.UploadFile .NoDragDrop button.v-btn) {
  margin: 0px !important;
}
.wrap-text {
  white-space: normal;
  word-wrap: break-word;
  overflow-wrap: break-word;
}

:deep(.v-data-table tbody tr) {
  transition: all 0.2s ease;
  border-bottom: 1px solid rgba(0, 0, 0, 0.06);
}

:deep(.v-data-table tbody tr:hover) {
  background: rgba(0, 0, 0, 0.02);
  /* transform: translateY(-1px); */
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
}

:deep(.v-data-table-header) {
  background: linear-gradient(135deg, #f8f9fa 0%, #e9ecef 100%);
  border-bottom: 2px solid #dee2e6;
}

:deep(.v-data-table-header th) {
  color: #495057 !important;
  font-weight: 700 !important;
  font-size: 0.875rem !important;
  padding: 1rem !important;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  border-bottom: 2px solid rgba(25, 118, 210, 0.1) !important;
}

:deep(.v-data-table.sorting-loading) {
  position: relative;
  pointer-events: none;
}

:deep(.v-data-table.sorting-loading::after) {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(255, 255, 255, 0.8);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 10;
}

/* Enhanced Sorting Indicators */
:deep(.v-data-table-header th.sortable) {
  cursor: pointer;
  transition: all 0.2s ease;
}

:deep(.v-data-table-header th.sortable:hover) {
  background: rgba(25, 118, 210, 0.05);
  color: #1976d2 !important;
}

:deep(.v-data-table-header th.sorted) {
  background: rgba(25, 118, 210, 0.1);
  color: #1976d2 !important;
}

/* Sorting Animation */
:deep(.v-data-table tbody) {
  transition: opacity 0.3s ease;
}

:deep(.v-data-table.sorting-loading tbody) {
  opacity: 0.6;
}

.modern-table :deep(.v-table__wrapper) {
  max-height: 600px;
  overflow-y: auto;
  scrollbar-width: thin;
  scrollbar-color: rgba(25, 118, 210, 0.3) rgba(0, 0, 0, 0.05);
}

.modern-table :deep(.v-table__wrapper thead th) {
  position: sticky;
  top: 0;
  z-index: 2;
  background: rgb(var(--v-theme-surface, 255, 255, 255));
}

.modern-table :deep(.v-table__wrapper::-webkit-scrollbar) {
  width: 6px;
}

.modern-table :deep(.v-table__wrapper::-webkit-scrollbar-track) {
  background: rgba(0, 0, 0, 0.05);
}

.modern-table :deep(.v-table__wrapper::-webkit-scrollbar-thumb) {
  background: rgba(25, 118, 210, 0.3);
  border-radius: 3px;
}

.modern-table :deep(.v-table__wrapper::-webkit-scrollbar-thumb:hover) {
  background: rgba(25, 118, 210, 0.5);
}
</style>
